var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2236",
    "data-name": "Group 2236",
    transform: "translate(-85 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M-756.668,651.69h-1.546c-.247-.032-.495-.059-.741-.095a10.837,10.837,0,0,1-5.655-2.565,10.814,10.814,0,0,1-3.7-6.653c-.045-.287-.084-.575-.127-.863v-1.632a1.091,1.091,0,0,0,.04-.141c.077-.5.121-1.008.231-1.5a11,11,0,0,1,13.069-8.282,11.007,11.007,0,0,1,8.505,12.542,10.814,10.814,0,0,1-3.442,6.316,10.713,10.713,0,0,1-5.475,2.7C-755.89,651.588-756.28,651.634-756.668,651.69Zm-8.905-14.251a20.42,20.42,0,0,1,16.269,0,8.672,8.672,0,0,0-8.173-5.53A8.659,8.659,0,0,0-765.573,637.439Zm16.884,3.908a4.541,4.541,0,0,0-2.22.615,9.415,9.415,0,0,0-4.586,6.154,10.288,10.288,0,0,0-.151,1.169A8.788,8.788,0,0,0-748.689,641.347Zm-17.491,0a8.747,8.747,0,0,0,6.941,7.931c-.039-.342-.058-.676-.117-1a8.875,8.875,0,0,0-1.848-3.931,8.26,8.26,0,0,0-3.335-2.651A4.468,4.468,0,0,0-766.181,641.347Zm8.758-2.286a1.623,1.623,0,0,0-1.655,1.608,1.625,1.625,0,0,0,1.619,1.666,1.624,1.624,0,0,0,1.655-1.609A1.624,1.624,0,0,0-757.423,639.061Z",
    transform: "translate(854.434 -614.703)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1115",
    "data-name": "Rectangle 1115",
    width: 24,
    height: 24,
    transform: "translate(85 14)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriving);
export default __webpack_public_path__ + "static/media/driving.23063af9.svg";
export { ForwardRef as ReactComponent };